<h2 mat-dialog-title>Confirm Recipient Information</h2>

<mat-dialog-content>
  <div class="confirmation-details">
    <div class="info-header">
      <mat-icon class="header-icon">{{ data.isAlternateRecipient ? 'person_outline' : 'account_circle' }}</mat-icon>
      <h3 class="header-title">{{ data.isAlternateRecipient ? 'Alternate Recipient' : 'Your Information' }}</h3>
    </div>
    
    <div class="info-card">
      <div class="info-row">
        <span class="info-label">Name:</span>
        <span class="info-value">{{ data.recipientName }}</span>
      </div>
      
      <div class="info-row">
        <span class="info-label">Address:</span>
        <div class="info-value address-lines">
          <div>{{ data.address1 }}<span *ngIf="data.address2">, {{ data.address2 }}</span></div>
          <div>{{ data.city }}, {{ data.state }} {{ data.zip }}</div>
        </div>
      </div>
    </div>
    
    <div class="confirmation-note">
      <mat-icon class="note-icon">info</mat-icon>
      <span>Please verify this information is correct before confirming.</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
